import { ChangeDetectionStrategy, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation,Renderer2 } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { callJSFun } from 'src/streaminglogs.js';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent, PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import { BehaviorSubject, Subject, Subscription, from, fromEvent, interval, of, timer } from 'rxjs';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { WebSocketService } from 'src/app/core/services/websocket.service';
import {throttleTime,filter, debounceTime, auditTime, concatMap, delay } from 'rxjs/operators';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
// declare function myFunction(token,id, event): any;
export interface LogEntry {
  data: any
}

@Component({
  selector: 'app-live-stream-logs',
  templateUrl: './live-stream-logs.component.html',
  styleUrls: ['./live-stream-logs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class LiveStreamLogsComponent implements OnInit, OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @ViewChild('scrollframe', { static: false }) scrollFrame: ElementRef;
  @ViewChild('logContainer', { static: true }) logContainer: ElementRef;
  @ViewChildren('item') itemElements: QueryList<any>;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;
  searching: boolean = false;
  search: string = "";
  page_min = 0;
  // ibID: number
  page_max = 10;
  total_records = 0;
  sortBy: string = '';
  orderBy: string = 'DESC';
  added: boolean = false;
  type;
  ibid: any;
  name: any;
  button_text: string = 'Add';
  received = [];
  content: [];
  sent: any = [];
  token: any;
  public logs: LogEntry[] = [];
  streamLogs: any = [];
  bubblecross = false;
  bubbleshow: boolean = false;
  sorcename: boolean = false;
  businessobjectname: boolean = false;
  businessname: boolean = false;
  businessobject: boolean = false;
  methodopt: boolean = false;
  requesturl: boolean = false;
  params: boolean = false;
  authorization: boolean = false;
  headers: boolean = false;
  requestbody: boolean = false;
  script: boolean = false;
  testurl: boolean = false;
  shownext: boolean = false;
  bubbleshowoperation: boolean = false;
  shownextoperation: boolean = false;
  bubbleshowtarget: boolean = false;
  targetname: boolean = false;
  businessobjecttargetname: boolean = false;
  businessobjecttarget: boolean = false;
  methodopttarget: boolean = false;
  requesturltarget: boolean = false;
  paramstarget: boolean = false;
  authorizationtarget: boolean = false;
  headerstarget: boolean = false;
  requestbodytarget: boolean = false;
  scripttarget: boolean = false;
  testurltarget: boolean = false;
  bubbly: number;
  shownexttarget: boolean = false;
  bridgename: boolean = false;
  schedule: boolean = false;
  submitib: boolean = false;
  hash_password: string;
  currentStatus: any = "";
  breadcrumbList = [
    {
      label: 'Integration',
      embedurl: true,
      url: '/baseapp/integration/list'
    },
    {
      label: 'Streaming logs',
      embedurl: false,
      url: ''
    }
  ];
  status: any;
  refreshBtn: boolean = false;
  connectInterval: any;
  mouseUpRef: any;
  streamlogtypes = ["INFO", "WARNING", "ERROR", "SYSTEM"];
  log_level: any = "INFO";
  count: any = 1;
  isDefault: boolean = false;
  dataStream$ = Observable<Array<any>>;
  // streamLogs$: Observable<Array<any>>;
  idTrackFn: any = 0;
  public webSocketSubscription: Subscription;
  alive = false;
  countd=0;
  scrollDrag = false;
  userScrolled=false;
  private logsRendered = 0;
  isPaused$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    public modalCtrl: ModalController,private renderer:Renderer2,
    public route: ActivatedRoute,
    public zone: NgZone,
    public helperService: HelperService,
    public backendService: BackendService,
    public storage: Storage,
    private sanitizer: DomSanitizer,
    public webSocketService: WebSocketService,
    private router: Router) {
    this.generatetoken();
    this.route.params.subscribe((params: Params) => {
      let streamObj = atob(params['id']);
      streamObj = JSON.parse(streamObj);
      this.ibid = streamObj["id"];//.split("=").join("");
      this.name = streamObj['name'];//.split("=").join("");
      const logContainer = this.logContainer?.nativeElement;
      if(logContainer){
        this.renderer.setProperty(logContainer, 'innerHTML', '');
      }
    });
    this.webSocketSubscription = this.webSocketService.getMessages().pipe(concatMap((message) => 
      of(message).pipe(delay(150),(filter(() => !this.isPaused$.value)))
    )).subscribe({
      next: (message) => {
        this.helperService.closeLoader();
        if(!this.alive){
            this.countd++;
            this.handleMessage(message);
      }
      },
      error: (error) => {
        helperService.closeLoader();
      }
    });
  }
  pauseWebSocket() {
    if (!this.isPaused$.value) {
      this.isPaused$.next(true);
    }
  }
 
  resumeWebSocket() {
    if (this.isPaused$.value) {
      this.isPaused$.next(false);
    }
  }

  handleMessage(message): void {
      let log = message.data.replaceAll(/\n/g, "<br />");
      log = log.split("<br />");
      for (let i of log) {
        if (i == "") {
        } else {
          let messageData = {};
          if (i.includes('INFO')) {
            if (i.includes('{"bizdata_dataset"')) {
              messageData = { id: this.count, body: this.formatJSON(JSON.parse(i)) };
            } else {
              messageData = { id: this.count, body: "<span class='info'>" + i + "</span>" };
            }
          } else if (i.includes('WARNING')) {
            if (i.includes('{"bizdata_dataset"')) {
              messageData = { id: this.count, body: this.formatJSON(JSON.parse(i)) };
            } else {
              messageData = { id: this.count, body: "<span class='warning'>" + i + "</span>" };
            }
          } else if (i.includes('ERROR') || i.includes('SYSTEM')) {
            if (i.includes('{"bizdata_dataset"')) {
              messageData = { id: this.count, body: this.formatJSON(JSON.parse(i)) };
            } else {
              messageData = { id: this.count, body: "<span class='system'>" + i + "</span>" };
            }
          }
          this.count++;
          this.appendLogs(messageData);
        }
      }

  };
  appendLogs(log: any): void {
    const logContainer = this.logContainer.nativeElement;
    const logElement = this.renderer.createElement('div');
    this.renderer.addClass(logElement, 'example-item');
    const logContent = this.renderer.createElement('div');
    this.renderer.addClass(logContent, 'streaming-body');
    const sanitizedHtml =`${log.id} ${log.body}`
    this.renderer.setProperty(logContent, 'innerHTML', sanitizedHtml);
    this.renderer.appendChild(logElement, logContent);
    this.renderer.appendChild(logContainer, logElement);
    if(logContainer.childNodes.length >= 150) {
      this.renderer.removeChild(logContainer, logContainer.firstChild);
    }
    if (!this.userScrolled) {
      logContainer.scrollTop = logContainer.scrollHeight;
    }
  };

  formatJSON(obj: Object): string {
    const escapeHtml = (str: string) => 
      str.replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;");
    const formattedStr = JSON.stringify(obj, null, 2);
    const formattedHtml = formattedStr
      .split("\n")
      .map(line => {
        const escapedLine = escapeHtml(line);
        const isCurlyBrace = escapedLine === "{" || escapedLine === "}";
        let spaceCount = 0;
        while (escapedLine[spaceCount] === " ") {
          spaceCount++;
        }
        const color = obj["level"] === 'INFO' ? '#000' :
                      obj["level"] === 'ERROR' || obj["level"] === 'SYSTEM' ? 'red' :
                      obj["level"] === 'WARNING' ? 'brown' : '#000';
        return `<div class="line" style="padding-left: ${!isCurlyBrace ? spaceCount / 2 : 0}em"><span style="color:${color}">${escapedLine}</span></div>`;
      })
      .join("");
   
    return formattedHtml;
  }

  ngOnInit() {
    const element = this.logContainer.nativeElement;
    element.addEventListener('scroll', () => {
      const atBottom =
      element.scrollHeight - element.scrollTop - element.clientHeight < 50;
      if (!atBottom) {
        this.userScrolled = true;
        this.pauseWebSocket();
      } else {
        this.userScrolled = false;
        element.scrollTop = element.scrollHeight;
        this.resumeWebSocket();
      }
    });
    this.helperService.getNavHelp().subscribe(toggle => {
      if (toggle) {
        this.closebubblecross();
      }
    });
    this.getStorage().then((res) => {
      this.token = res.token;
      // this.helperService.loader();
      if (this.status == "Start") {
        if (this.isDefault == true) {
          this.isDefault = false;
          this.scrollDrag = false;
          this.currentStatus = "open";
          // callJSFun(this.hash_password, this.ibid, "open", this.log_level);
          this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "open", this.log_level)
        }
      }

      this.helperService.changes.subscribe((data) => {
        if (typeof data.value === 'object' &&
          !Array.isArray(data.value)) {
          if (data.value.id == this.ibid) {
            if (this.status != data.value.status) {
              if (data.value.status == "Start") {
                this.status = "Start";
                //  callJSFun(this.hash_password, this.ibid, "close", this.log_level);
                this.currentStatus = "open";
                // callJSFun(this.hash_password, this.ibid, "open", this.log_level);
                this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "open", this.log_level);
                this.alive = false;
                // if(this.isDefault){
                //   this.startDragging("",false);
                // }                
              } else {
                this.status = "Stop";
                this.currentStatus = "close";
                this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "close", this.log_level);
                // this.stopStreamData$.next(true);
                this.alive = true;
              }
            }
          }
        } else if (Array.isArray(data.value)) {
          for (let i of data.value) {
            if (i.id == this.ibid) {
              if (this.status != i.status) {
                if (i.status == "Start") {
                  // this.connectInterval = setTimeout(this.toggleRefresh.bind(this), 900000);
                  this.status = "Start";
                  this.scrollDrag = false;
                  this.currentStatus = "open";
                  this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "open", this.log_level);
                  this.alive = false;
                  // callJSFun(this.hash_password, this.ibid, "open", this.log_level);
                } else {
                  this.status = "Stop";
                  // clearInterval(this.connectInterval);
                  this.currentStatus = "close";
                  this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "close", this.log_level);
                  // this.stopStreamData$.next(true);
                  // this.stopStreamData$.complete();
                  this.alive = true;
                }
              }
            }
          }
        }
        // this.helperService.closeLoader();
      })
      // setTimeout(() => {
      //   this.helperService.closeLoader();
      // }, 5000);
      document.addEventListener("visibilitychange", () => {
          this.helperService.closeLoader();
      });
    })
  }
  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog"),
      catalogobjtype: await this.storage.get("catalogobjtype"),
      ibid: await this.storage.get("ibid")
    }
    return data;
  }
  generatetoken(type?) {
    this.type = 'data_source'
    this.getStorage().then(async (res) => {
      await this.helperService.loader();
      let payload = {
        type: this.type
      }
      this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
        (data) => {
          this.hash_password = data['data'][0].hashed_password;
          this.getListOfIds();
        },
        (error) => {
          this.helperService.closeLoader();
          //console.log(error);
        }
      );
    })
  }
  getListOfIds() {
    let listOfIds = this.helperService.getStorage();
    for (let i = 0; i < listOfIds.length; i++) {
      if (listOfIds[i].id == this.ibid) {
        if (listOfIds[i].status == "Start") {
          let obj = { id: this.ibid, status: "Start" };
          this.helperService.store("status", obj);
          this.status = listOfIds[i].status;
          this.isDefault = true;
          this.currentStatus = "open";
        } else {
          this.helperService.closeLoader();
          this.currentStatus = "";
          this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "", this.log_level)
          // callJSFun(this.hash_password, this.ibid, "", this.log_level);
        }
      }
    }

  }
  ngOnDestroy(): void {
    this.alive = false; // switches your IntervalObservable off
    this.webSocketSubscription.unsubscribe();
    this.helperService.clear(this.ibid);
    this.helperService.stop();
  }

  closebubblecross() {
    this.bubbleshow = false;
    this.businessobject = false;
    this.sorcename = false;
    this.businessobjectname = false;
    this.methodopt = false;
    this.requesturl = false;
    this.authorization = false;
    this.headers = false;
    this.testurl = false;
    this.shownext = false;
    this.bubbleshowoperation = false;
    this.bubbleshowtarget = false;
    this.targetname = false;
    this.businessobjecttargetname = false;
    this.businessobjecttarget = false;
    this.methodopttarget = false;
    this.requesturltarget = false;
    this.authorizationtarget = false;
    this.headerstarget = false;
    this.testurltarget = false;
    this.shownexttarget = false;
    this.bridgename = false;
    this.schedule = false;
    this.submitib = false;
  }
  toggleRefresh() {
    this.refreshBtn = !this.refreshBtn;
  }
  refreshPage() {
    this.refreshBtn = false;    
    this.alive = true;
    this.count = 1;
    const logContainer = this.logContainer.nativeElement;
    this.renderer.setProperty(logContainer, 'innerHTML', '');
    this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "close", this.log_level);
    this.changeOrReconnect();
  }

  OnChangeStreamlogType(event) {
    this.alive = true;
    this.count = 1;
    const logContainer = this.logContainer.nativeElement;
    this.renderer.setProperty(logContainer, 'innerHTML', '');
      this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, "close", this.log_level);
      this.log_level = event.value;
      this.changeOrReconnect();
  }
  changeOrReconnect() {
    this.webSocketService.initializeWebSocket(this.hash_password, this.ibid, this.currentStatus, this.log_level);
    this.alive = false;
  }
}
